export const gitnum = {
      version: 'v1.3.126',
      git: '126',
      branch: 'contributions2026b',
      commit: '1c3485c',
      describe: 'v1.3',
      date:'05/10/2026 10:13'
    };
    